import { render } from "./CreateContentPage.vue?vue&type=template&id=7f7db256&ts=true"
import script from "./CreateContentPage.vue?vue&type=script&lang=ts"
export * from "./CreateContentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Contents/CreateContentPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f7db256"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f7db256', __exports__)) {
    api.reload('7f7db256', __exports__)
  }
  
  module.hot.accept("./CreateContentPage.vue?vue&type=template&id=7f7db256&ts=true", () => {
    api.rerender('7f7db256', render)
  })

}


export default __exports__